var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "easy-access_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469",
    stopOpacity: 0.219
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "easy-access_svg__b",
    x1: "0%",
    x2: "100%",
    y1: "78.241%",
    y2: "21.759%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "url(#easy-access_svg__a)",
    rx: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.485 11.558c.71 0 1.273.564 1.273 1.274 0 .71-.563 1.273-1.273 1.273-.392 0-.735-.171-.98-.44-.244.269-.587.44-.98.44-.71 0-1.273-.563-1.273-1.273s.564-1.274 1.274-1.274c.392 0 .735.172.98.441.244-.27.587-.44.979-.44zm8.89-1.2V9.183H7.518v4.996c0 .392.318.71.71.71h8.033a5.1 5.1 0 00.22 1.25H8.252a1.992 1.992 0 01-1.983-1.985V7.052a1.99 1.99 0 011.983-1.983H19.47a1.99 1.99 0 011.983 1.983v3.355a4.497 4.497 0 00-.808-.073c-.122 0-.196.024-.27.024zm0-3.06v-.27a.71.71 0 00-.71-.71H8.228a.71.71 0 00-.71.71v.27h12.857zm-17.02 6.905a2.015 2.015 0 001.91 1.102 2.914 2.914 0 01-.22-1.15V7.051a3.218 3.218 0 013.207-3.208h6.882L13.787 1.1a1.994 1.994 0 00-2.645-.906L1.102 5.191a1.994 1.994 0 00-.907 2.645l3.16 6.367zm20.4.515a3.126 3.126 0 01-3.135 3.134 3.124 3.124 0 01-3.135-3.134 3.125 3.125 0 013.135-3.135c1.738-.025 3.134 1.396 3.134 3.135zm-3.527-1.445c0 .294.22.514.514.514.27 0 .514-.22.514-.514a.502.502 0 00-.514-.515.534.534 0 00-.514.515zm1.126 2.84l-.147.074c-.073.025-.122.049-.195.049-.074 0-.147-.024-.147-.098-.025-.049-.025-.122-.025-.171.025-.123.05-.245.05-.368.073-.367.146-.734.195-1.102.024-.098.024-.196.024-.294 0-.122-.073-.171-.195-.171h-1.078c-.073.024-.098.049-.122.098 0 .049.024.098.098.122.049.025.122.025.171.025.122.024.171.073.171.196v.073c-.049.319-.122.637-.171.955l-.074.564c-.048.269.22.514.417.563.122.024.245.024.367.024.27 0 .49-.122.686-.294a.52.52 0 00.073-.122c.05-.098-.024-.147-.098-.122z",
    fill: "url(#easy-access_svg__b)",
    transform: "translate(9 12)"
  }))));
}
export default SvgEasyAccess;